import React from 'react';
import {Create, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import CongBoDiemFields from './CongBoDiemFields'

export const CongBoDiemCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
            <Grid container spacing={8}>
                <CongBoDiemFields/>
            </Grid>
        </SimpleForm>
    </Create>
);

export default CongBoDiemCreate
